/* actions/actions */
import { action } from "typesafe-actions";
import { Card, CardActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(CardActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Card) =>
  action(CardActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(CardActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Card | null) => unknown
) => action(CardActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Card) =>
  action(CardActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(CardActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(CardActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(CardActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(CardActionTypes.DELETE_ERROR, error);
